var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-card",
        { staticClass: "multi-card" },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "6" } }, [
                    _c("h5", [_vm._v(_vm._s(_vm.$t("CONFIGURED.ROLE_ORDER")))])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "6" } }, [
                    _c(
                      "div",
                      { staticClass: "float-right add-field-btn" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.newRole",
                                modifiers: { newRole: true }
                              }
                            ],
                            staticClass: "mt-0",
                            attrs: {
                              type: "submit",
                              size: "sm",
                              variant: "secondary"
                            },
                            on: { click: _vm.clearRoleModal }
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CONFIGURED.ADD_ROLE")) +
                                  " "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-0",
                            attrs: {
                              type: "submit",
                              variant: "secondary",
                              size: "sm"
                            },
                            on: { click: _vm.updateRoleOrder }
                          },
                          [
                            _c("i", { staticClass: "fa fa-save" }),
                            _vm._v(" " + _vm._s(_vm.$t("COMMON.SAVE")))
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "timeline-div" }, [
            _c(
              "ul",
              { staticClass: "timeline timeline-horizontal" },
              [
                _c(
                  "draggable",
                  {
                    staticClass: "flex-container",
                    attrs: { options: { group: "roles" } },
                    model: {
                      value: _vm.selectedRoles,
                      callback: function($$v) {
                        _vm.selectedRoles = $$v
                      },
                      expression: "selectedRoles"
                    }
                  },
                  _vm._l(_vm.selectedRoles, function(role, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "timeline-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "timeline-badge bg-primary" },
                          [_c("strong", [_vm._v(_vm._s(index + 1))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "timeline-panel role-panel" },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm._f("titlize")(role["name"])))
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "panel-option",
                                attrs: { "no-caret": "" }
                              },
                              [
                                _c("template", { slot: "button-content" }, [
                                  _c("div", [
                                    _c("i", { staticClass: "fa fa-ellipsis-v" })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal.editRole",
                                        modifiers: { editRole: true }
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        _vm.setEditRole(role)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.EDIT")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal.deleteRole",
                                        modifiers: { deleteRole: true }
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        _vm.setDeleteRole(role)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.DELETE")))]
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]
                    )
                  })
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("em", { staticClass: "italic" }, [
            _vm._v(_vm._s(_vm.$t("CONFIGURED.ROLE_NOTE")))
          ]),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "newRoleModal",
              attrs: {
                "hide-header-close": "",
                id: "newRole",
                title: _vm.$t("CONFIGURED.NEW_ROLE"),
                "header-bg-variant": "light",
                centered: ""
              }
            },
            [
              _c(
                "b-card",
                { staticClass: "mb-0 p-3" },
                [
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("CONFIGURED.ROLE_NAME"),
                                "label-for": "roleName"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "rolename",
                                class: {
                                  "is-invalid": _vm.$v.newRoleName.$error,
                                  "is-valid": !_vm.$v.newRoleName.$invalid
                                },
                                attrs: {
                                  id: "roleName",
                                  type: "text",
                                  placeholder: _vm.$t("CONFIGURED.ROLE_NAME")
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.newRoleName.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.newRoleName,
                                  callback: function($$v) {
                                    _vm.newRoleName = $$v
                                  },
                                  expression: "newRoleName"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.required
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v("Role Name can't be blank")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.valid
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v("Role Name can't accept symbols")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.minLength ||
                              !_vm.$v.newRoleName.maxLength
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      "Role Name length should be more than 3 and less than 15 characters"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.isUnique
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      "Either role is already registered or not allowed."
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.createRole }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("CONFIGURED.CREATE")) + " ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: { size: "sm", variant: "light" },
                      on: { click: _vm.hideCreateRoleModal }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "deleteRoleModal",
              attrs: {
                "hide-header-close": "",
                id: "deleteRole",
                title: "Role Delete Confirmation",
                "header-bg-variant": "light",
                centered: ""
              }
            },
            [
              _c(
                "b-card",
                { staticClass: "mb-0" },
                [
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("p", [
                          _vm._v("Are you sure you want to delete the role '"),
                          _c("strong", { staticClass: "text-capitalize" }, [
                            _vm._v(_vm._s(_vm.selectedRole.name))
                          ]),
                          _vm._v("' ?")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "This may affect the forms and users under this role."
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: { click: _vm.deleteRole }
                    },
                    [_vm._v(" Delete ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: { size: "sm", variant: "light" },
                      on: { click: _vm.hideDeleteRoleModal }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "editRoleModal",
              attrs: {
                "hide-header-close": "",
                id: "editRole",
                title: "Edit Role Name",
                "header-bg-variant": "light",
                centered: ""
              }
            },
            [
              _c(
                "b-card",
                { staticClass: "mb-0 p-3" },
                [
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("CONFIGURED.ROLE_NAME"),
                                "label-for": "roleName"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "rolename",
                                class: {
                                  "is-invalid": _vm.$v.newRoleName.$error,
                                  "is-valid": !_vm.$v.newRoleName.$invalid
                                },
                                attrs: {
                                  id: "roleName",
                                  type: "text",
                                  placeholder: _vm.$t("CONFIGURED.ROLE_NAME")
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.newRoleName.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.newRoleName,
                                  callback: function($$v) {
                                    _vm.newRoleName = $$v
                                  },
                                  expression: "newRoleName"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.required
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v("Role Name can't be blank")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.valid
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v("Role Name can't accept symbols")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.minLength ||
                              !_vm.$v.newRoleName.maxLength
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      "Role Name length should be more than 3 and less than 15 characters"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$v.newRoleName.isUnique
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      "Either role is already registered or not allowed."
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        size: "sm",
                        variant: "secondary",
                        disabled: _vm.$v.newRoleName.$error
                      },
                      on: { click: _vm.editRole }
                    },
                    [_vm._v(" Change ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: { size: "sm", variant: "light" },
                      on: { click: _vm.hideEditRoleModal }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b442dcc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b442dcc8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/roleOrder.vue
// module id = 1337
// module chunks = 2